/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicStripeModule
 */
export interface PublicStripeModule {
    /**
     * 
     * @type {boolean}
     * @memberof PublicStripeModule
     */
    enabled?: boolean;
    /**
     * Stripe publishable key for Elements
     * @type {string}
     * @memberof PublicStripeModule
     */
    public_key?: string;
}

/**
 * Check if a given object implements the PublicStripeModule interface.
 */
export function instanceOfPublicStripeModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicStripeModuleFromJSON(json: any): PublicStripeModule {
    return PublicStripeModuleFromJSONTyped(json, false);
}

export function PublicStripeModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicStripeModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'public_key': !exists(json, 'public_key') ? undefined : json['public_key'],
    };
}

export function PublicStripeModuleToJSON(value?: PublicStripeModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'public_key': value.public_key,
    };
}

